import { render, staticRenderFns } from "./my-todo-task.vue?vue&type=template&id=46ab8b25&"
import script from "./my-todo-task.vue?vue&type=script&lang=js&"
export * from "./my-todo-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports